import React, { useEffect, useState } from 'react';
import { Button, Table, usePromise } from '@digital/ui';
import { Modal, Collapse, Tooltip, Icon } from 'antd';
import { ColumnProps } from 'antd/lib/table';
import { AnexoDemanda, downloadAnexoDemanda, getAnexosDemanda, viewAnexoDemanda } from '@app/api/demanda';
import { GetFileExtension, imageFormats } from '@app/helpers';

const columns: ColumnProps<any>[] = [
  {
    title: 'Descrição Documento',
    dataIndex: 'descricaoDocumento',
  },
  {
    title: 'Arquivo',
    dataIndex: 'arquivoAtual.nome',
  },
  {
    title: 'Ações',
    width: '10%',
    render: (text, record) => (
      <>
        {record.arquivoAtual && record.arquivoAtual.local && (
          <>
            {GetFileExtension(record.arquivoAtual.nome) === 'pdf' ||
            imageFormats.includes(GetFileExtension(record.arquivoAtual.nome)) ? (
              <Tooltip title="Visualizar Arquivo">
                <Button
                  icon="files-view_file"
                  type="link"
                  onClick={() => {
                    viewAnexoDemanda(record.arquivoAtual.id, record.arquivoAtual.nome);
                  }}
                />
              </Tooltip>
            ) : (
              <></>
            )}
          </>
        )}
      </>
    ),
  },
];
interface Props {
  demandaId: string;
}

const ModalListaAnexo = (props: Props) => {
  const { demandaId } = props;
  const [mostrarModal, setMostrarModal] = useState(false);
  const [dados, setDados] = useState<AnexoDemanda[]>([]);

  useEffect(() => {
    if (mostrarModal === true) {
      getAnexosDemanda({
        demandaId: demandaId,
        filtroExibir: false
      }).then(data => {
        if (data) {
          setDados(data);
        }
      });
    }
  }, [mostrarModal]);

  return (
    <>
      <Tooltip title="Anexos">
        <Button onClick={() => setMostrarModal(true)} icon="messaging-attach" />
      </Tooltip>
      <Modal
        title="Anexos"
        className="chat-modal"
        width="800px"
        visible={mostrarModal}
        onCancel={() => setMostrarModal(false)}
        footer={[
          <Button
            key="fecharButton"
            type="link"
            onClick={() => {
              setMostrarModal(false);
            }}>
            Fechar
          </Button>,
        ]}>
        <Table columns={columns} dataSource={dados} pagination={false} rowKey="id" />
      </Modal>
    </>
  );
};
export default ModalListaAnexo;
